export default target => {
  if (!target) {
    return 'undefined';
  }
  if ('name' in target) {
    return target.name;
  }
  if (target.prototype) {
    return target.prototype.constructor.name;
  }
  return target.constructor.name;
};
